import React, { useState, useRef } from "react";
import { makeStyles } from "@material-ui/core";
// @ts-ignore
import { useParams } from 'react-router-dom'
import { Input } from "./input"
import { Select } from "./select";
import store from "src/store";
import { requestJSON } from "src/utils/request-module";
import CustomModal from "./custom-modal";
import InputText from "./input-text";
import { DialogContentText } from "@material-ui/core";
import { CopyIcon, EditIcon } from "./icons-svg";
import copyToClipboard from "copy-to-clipboard";
import Tooltip from "./tooltip";

const useStyles = makeStyles({
  icon: {
    display: 'inline-block',
    fontSize: '18px',
    color: '#2E2E38',
    marginLeft: '10px'
  },
  clickable: {
    cursor: 'pointer',
  }
});

var parameterStyle = {
  padding: "10px 5px",
}
/**
 * @param props {object}
 * @param props.value {any}
 * @param props.onChange {any}
 * @param props.label {string}
 */
export default function AddressInput(props) {
  const { id } = useParams();
  const classes = useStyles();

  /** It's include dynamic */
  store.useRerenderIfChange(() => [
    store.getSelectedSimulationAddressListObj(),
  ])

  const defaultCopyTip = "Copy to clipboard"
  const [copyTip, setCopyTip] = useState(defaultCopyTip);
  const [showSelectList, setShowSelectList] = useState(true);
  const [showAddressNameModal, setShowAddressNameModal] = useState(false);
  const [newAddress, setnewAddress] = useState(null);
  const [addressName, setAddressName] = useState('');
  const [addressHasName, setAddressHasName] = useState(false);
  const [addressNameHasError, setAddressNameHasError] = useState(false);
  const [addressNameErrorText, setAddressNameErrorText] = useState('');

  var Style = { ...parameterStyle, width: 440 }
  var value = props.value && String(props.value)
  value = value?.replace(/[^A-Fa-f0-9x]/g, "")
  value = value?.slice(0, 42)
  if (value && !value.match(/^0x[a-fA-F0-9]{40}/)) {
    Style = {
      ...Style
    }
  }

  const onSubmitAddress = (address) => {
    if (store.getSelectedSimulationAddressListObj().hasOwnProperty(address)) {
      setAddressHasName(true);
      setAddressName(store.getSelectedSimulationAddressListObj()[address]);
    } else {
      setAddressHasName(false);
      setAddressName('');
    }
    setnewAddress(address);
    setShowAddressNameModal(true);
  }

  const onModalClose = () => {
    setAddressName("");
    setAddressHasName(false);
    setAddressNameHasError(false);
    setAddressNameErrorText("");
    setShowAddressNameModal(false);
    setShowSelectList(true);
  }

  const updateAddressList = async () => {
    store.selectedSimulationAddressList[newAddress] = addressName;
    store.updateStore()
    try {
      await requestJSON("PUT", '/simulation/' + id, { addressList: store.selectedSimulationAddressList });
    } catch (err) {
      console.log('Some error has occured while updating address list ', err);
    } finally {
      onModalClose();
    }
  }

  const copy = () => {
    copyToClipboard(value)
    setCopyTip("Copied!")
    setTimeout(() => {
      try { // in timeout might be an error of updating unmounted component
        setCopyTip(defaultCopyTip)
      } catch (err) {
        const noop = function () { }
        noop() // eslint don't allow empty blocks
      }
    }, 2000)
  }

  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      <CustomModal
        size="medium"
        title="Add name"
        showModal={showAddressNameModal}
        onCloseModal={() => {
          onModalClose()
        }}
        submitBtnText={addressName? 'Update' : 'Delete'}
        onSubmit={(e) => { e.preventDefault(); updateAddressList() }}
        submitBtnDisabled={false}
      >
        <>
          <DialogContentText color="textPrimary">
            {
              addressHasName ? "The address " + newAddress + " already have a name. Please update if you want to change." :
                "The address " + newAddress + " does not have a name yet. Please enter a name."
            }
          </DialogContentText>
          <form onSubmit={(e) => { e.preventDefault(); updateAddressList() }}>
            <div css="margin-top: 15px;">
              <InputText
                id={"addressName"}
                label={"Name"}
                value={addressName}
                disabled={false}
                onChange={(value) => { setAddressName(value) }}
                hasError={addressNameHasError}
                errorText={addressNameErrorText}
              />
            </div>
          </form>
        </>
      </CustomModal>
      <div css={`
        width:100%;
        display:inline-block;
      `}>
        {
          showSelectList ?
            <>
              <div css="
              display: flex;   
              align-items: center;">
                <div css="flex-grow: 1;">
                  <Select
                    label={props.label}
                    labelBackground={props.labelBackground}
                    value={value || ""}
                    size="small"
                    disabled={props.hasOwnProperty('disabled') && props['disabled']}
                    onChange={e => {
                      if (e.target.value == 'showManualAddress') {
                        setShowSelectList(false);
                      } else {
                        props.onChange(e);
                      }
                    }}
                  >
                    {
                      store.getSelectedSimulationAddressListArr().map((item) => (
                        <option key={item.address} value={item.address}>{item.name ?
                          item.name +
                          '(' + (item.name.length > 6 ? store.shortenedAddress(item.address) : item.address) + ')' :
                          item.address
                        }</option>
                      ))
                    }
                    <option value={'showManualAddress'}>Type manual address</option>
                  </Select>
                </div>
                {
                  !props['disabled'] &&
                  <>
                    <div>
                      <span className={`${classes.icon} ${classes.clickable}`} onClick={() => {
                        setShowSelectList(false);
                      }}>{EditIcon(14)}</span>
                    </div>
                  </>
                }
                <div>
                  <Tooltip tip={copyTip}>
                    <span 
                    css={`visibility:${value? 'visible':'hidden'};`}
                    className={`${classes.icon} ${classes.clickable}`} onClick={() => {
                      copy();
                    }}>{CopyIcon(14)}</span>
                  </Tooltip>
                </div>
              </div>
            </>
            :
            <>
              <Input
                {...props}
                isValidFunc={x => value?.match(/^0x[a-fA-F0-9]{40}/)}
                value={value || ""}
                maxLength={42}
                placeholder="0x..."
                label={props.label}
                labelBackground={props.labelBackground}
                onBlur={(e) => {
                  props.onChange(e);
                  setTimeout(()=> {
                    setShowSelectList(true);
                  }, 200)
                }}
                onAddBtnClick={() => {
                  if (value && value.match(/^0x[a-fA-F0-9]{40}/)) {
                    onSubmitAddress(value || "");
                  } else {
                    console.log('Address either invalid. Cannot add name.')
                  }
                }}
                onClear={() => {
                  setShowSelectList(true);
                }}
              />
            </>
        }
      </div>
      {/* <div css={`
      vertical-align:middle;
      padding-left:5px;
      display:inline-block;
      `}>
        <ShowContractName address={value || ""} />
      </div> */}
    </div>
  )
}
